import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-765198f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "เรื่อง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["data-bs-content"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }, null, -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "text-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enjoins, (enjoin, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "row-hover",
                  onClick: ($event: any) => (_ctx.selectedClick(enjoin.id))
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", {
                    class: "column-name text-truncate",
                    "data-bs-toggle": "popover-enjoin",
                    "data-bs-content": enjoin.title
                  }, [
                    _hoisted_6,
                    _createTextVNode(_toDisplayString(enjoin.title), 1)
                  ], 8, _hoisted_5),
                  _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(enjoin.createdAt)), 1),
                  _createElementVNode("td", _hoisted_7, [
                    (enjoin.answers.length === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "ยังไม่ได้รายงานผล"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "รายงานผลแล้ว"))
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ])
          ], 512)
        ]))
  ]))
}